import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout'
import { Message } from 'element-ui';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: 'homeLayout',
    children: [
      {
        path: '/homeLayout',
        name: 'homeLayout',
        component: () => import('@/views/home/index'),
        meta: {
          title: '主页'
        }
      },
      {
        path: '/advance',
        name: 'advance',
        component: () => import('@/views/advance/index'),
        meta: {
          title: '高级搜索'
        }
      },
      {
        path: '/searchList',
        name: 'searchList',
        component: () => import('@/views/searchList/index'),
        meta: {
          title: '搜索列表'
        }
      },
      {
        path: '/detail',
        name: 'detail',
        component: () => import('@/views/detail/index'),
        meta: {
          title: '数据详情'
        }
      },
      {
        path: '/apply',
        name: 'apply',
        component: () => import('@/views/apply/index'),
        meta: {
          title: '应用'
        }
      },
      {
        path: '/setMeal',
        name: 'setMeal',
        component: () => import('@/views/setMeal/index'),
        meta: {
          title: '企业套餐'
        }
      },
      {
        path: '/solution',
        name: 'solution',
        component: () => import('@/views/solution/index'),
        meta: {
          title: '解决方案'
        }
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product/index'),
        meta: {
          title: '产品'
        }
      },
      {
        path: '/excelList',
        name: 'excelList',
        component: () => import('@/views/excelList/index'),
        meta: {
          title: '导出数据'
        }
      },
      {
        path: '/mall',
        name: 'mall',
        component: () => import('@/views/mall/index'),
        meta: {
          title: '商城'
        }
      },
      {
        path: '/map',
        name: 'map',
        component: () => import('@/views/map/index'),
        meta: {
          title: '城市'
        }
      },
    ]

  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/index'),
  }

]

const router = new VueRouter({
  routes
})
//路由白名单
const whiteList = [
  '/homeLayout',
  '/login',
  "/register",
  '/setMeal',
  '/mall'
]
//挂载路由守卫
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path)!== -1 ) return next();
  //获取token
  const tokenStr = window.localStorage.getItem('token')
  if (!tokenStr) {
    Message("请先登录！")
    return next('/');
  }
  next();
})
export default router
